import usePageContext from '@rover/react-lib/src/context/usePageContext';
import { selectors as footerSelectors } from '@rover/react-lib/src/redux/ducks/footer.duck';
import { Footer, useApiFrontendFooterRetrieve } from '@rover/rsdk/src/apiClient/latest';

import useDucks from './useDucks';

export type FooterData = {
  footer?: Footer;
};

const selector = (state): FooterData => ({
  footer: footerSelectors.getFooter(state),
});

const useFooterShim = (): FooterData => {
  const { isReactQueryRoute } = usePageContext();

  const { data } = useApiFrontendFooterRetrieve({ query: { enabled: isReactQueryRoute } });
  const { data: selectedData } = useDucks({ selector });

  if (isReactQueryRoute) {
    return { footer: data };
  }
  return {
    footer: selectedData.footer,
  };
};

export default useFooterShim;
